import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="account-intro"]' },
  { target: '[data-tour="screen-help-dot"]' },
  { target: '[data-tour="account-tabs"]' },
  { target: '[data-tour="account-panel"]' },
  { target: '[data-tour="account-danger"]' }
];

export const PROFILE_ACCOUNT_TOUR_STEPS: TourStep[] = buildTourSteps('profileAccount', STEP_DEFS);

export const PROFILE_ACCOUNT_TOUR_STORAGE_KEY = 'wetree-profile-account-tour-completed';
